import { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Col,
  Row,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { FaUserCircle } from "react-icons/fa";

function AgentProfile({ show, handleClose, user }) {
  const userId = localStorage.getItem("userId");
  const [initialData, setInitialData] = useState(null);
  const [activeTab, setActiveTab] = useState("employee");
  const [formData, setFormData] = useState({
    first_name: "",
    emp_id: "",
    last_name: "",
    email: "",
    phone_number: "",
    date_joined: "",
    attendence_type: "web/app",
    designation: "",
    department: "",
    gender: "",
    employment_type: "permanent",
    profile_image: null,
    family: {
      father_first_name: "",
      father_last_name: "",
      mother_first_name: "",
      mother_last_name: "",
      marital_status: "",
      spouse_first_name: "",
      spouse_last_name: "",
    },
    bank: {
      account_no: "",
      bank_name: "",
      ifsc: "",
      branch: "",
      payment_type: "",
    },
    other: {
      blood_group: "",
      religion: "",

      nationality: "",
    },
    salary: {
      earnings: {
        basic: "",
        hra: "",
        conveyance: "",
        special: "",
        other: "",
      },
      deductions: {
        advance: "",
        other: "",
      },
    },
    qualifications: [
      { qualification: "", board: "", marks: "", grade: "", year: "" },
    ],
    experiences: [
      {
        company: "",
        designation: "",
        years: "",
        salary: "",
        reason: "",
      },
    ],
    resident: {
      res_address: "",
      res_country: "",
      res_state: "",
      res_city: "",
      res_pincode: "",
    },

    permanent: {
      perm_same_as_res: false,

      perm_address: "",
      perm_country: "",
      perm_state: "",
      perm_city: "",
      perm_pincode: "",
    },
    contact: {
      mobile_no: "",
      emergency_no: "",
    },
  });

  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (user) {
      const mapped = {
        emp_id: String(user.emp_id || ""),
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        email: user.email || "",
        phone_number: user.phone_number || "",
        profile_image: user.profile_image || null,
        designation: user.designation || "",
        department: user.department || "",
        gender: user.gender || "",
        employment_type: user.employment_type || "permanent",

        date_joined: user.date_joined || "",
        attendence_type: user.attendence_type || "web/app",
        family: user.family_details || formData.family,
        bank: user.bank_details || formData.bank,
        other: user.other_details || formData.other,
        resident: user.resident_details || formData.resident,
        permanent: user.permanent_details || formData.permanent,
        contact: user.contact_details || formData.contact,

        salary: {
          earnings: {
            basic: user.salary?.earnings?.basic || "",
            hra: user.salary?.earnings?.hra || "",
            conveyance: user.salary?.earnings?.conveyance || "",
            special: user.salary?.earnings?.special || "",
            other: user.salary?.earnings?.other || "",
          },
          deductions: {
            advance: user.salary?.deductions?.advance || "",
            other: user.salary?.deductions?.other || "",
          },
        },

        qualifications:
          user.qualifications?.length > 0
            ? user.qualifications
            : formData.qualifications,

        experiences:
          user.experiences?.length > 0
            ? user.experiences.map((exp) => ({
                company: exp?.company || "",
                designation: exp?.designation || "",
                years: exp?.years || "",
                salary: exp?.salary || "",
                reason: exp?.reason || "",
              }))
            : formData.experiences,
      };
      setFormData(mapped);
      setInitialData(mapped);
      setPreviewImage(user.profile_image || null);
    }
  }, [user]);

  const addRow = (section, emptyRow) => {
    setFormData((prev) => ({
      ...prev,
      [section]: [...prev[section], emptyRow],
    }));
  };
  /* =====================================================
     🔢 HELPERS
     ===================================================== */

  const handleSameAddress = (checked) => {
    setFormData((prev) => ({
      ...prev,
      permanent: {
        ...prev.permanent,
        perm_same_as_res: checked,
        perm_address: checked ? prev.resident.res_address : "",
        perm_country: checked ? prev.resident.res_country : "",
        perm_state: checked ? prev.resident.res_state : "",
        perm_city: checked ? prev.resident.res_city : "",
        perm_pincode: checked ? prev.resident.res_pincode : "",
      },
    }));
  };

  const updateField = (field, value) => {
    setFormData((p) => ({
      ...p,
      [field]: value,
    }));
    setErrors((e) => ({ ...e, [field]: "" }));
  };
  const updateNestedField = (parent, child, value) => {
    setFormData((prev) => ({
      ...prev,
      [parent]: {
        ...prev[parent],
        [child]: value,
      },
    }));
  };

  const updateArrayField = (section, index, field, value) => {
    setFormData((prev) => {
      const updated = [...(prev[section] || [])];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return { ...prev, [section]: updated };
    });
  };

  const handleNumericField = (field, value, maxLength) => {
    let v = value.replace(/\D/g, "");
    if (maxLength) v = v.slice(0, maxLength);
    setFormData((p) => ({ ...p, [field]: v }));
  };

  /* =====================================================
     ✅ TAB-1 VALIDATION
     ===================================================== */
  const removeRow = (section, index) => {
    setFormData((prev) => {
      if (prev[section].length === 1) return prev; // keep at least one row

      const updated = prev[section].filter((_, i) => i !== index);
      return { ...prev, [section]: updated };
    });
  };
  const validateEmployeeTab = () => {
    const err = {};

    if (!/^\d{1,4}$/.test(formData.emp_id))
      err.emp_id = "User ID required (1–4 digits)";

    if (!formData.first_name) err.first_name = "First name required";

    if (!/^\d{10}$/.test(formData.phone_number))
      err.phone_number = "10 digit mobile required";

    if (!/\S+@\S+\.\S+/.test(formData.email))
      err.email = "Valid email required";

    if (!formData.date_joined) err.date_joined = "Date of joining required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, profile_image: file });
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const buildPayload = () => {
    const payload = {
      emp_id: formData.emp_id,
      first_name: formData.first_name,
      last_name: formData.last_name,
      phone_number: formData.phone_number,
      email: formData.email,
      date_joined: formData.date_joined,
      attendence_type: formData.attendence_type,

      profile_image: formData.profile_image || null,
      designation: formData.designation || "",
      department: formData.department || "",
      gender: formData.gender || "",
      employment_type: formData.employment_type || "permanent",

      family_details: formData.family,
      bank_details: formData.bank,
      other_details: formData.other,
      resident_details: formData.resident,
      permanent_details: formData.permanent,
      contact_details: formData.contact,
      salary: formData.salary,

      qualifications: formData.qualifications,
      experiences: formData?.experiences,
    };

    if (initialData) {
      Object.keys(payload).forEach((k) => {
        // ✅ Always send full communication object
        if (k === "communication_details") return;

        if (JSON.stringify(payload[k]) === JSON.stringify(initialData[k])) {
          delete payload[k];
        }
      });
    }

    return payload;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const payload = buildPayload(); // ✅ use mapped payload
    const formDataToSend = new FormData();

    // append normal + nested data
    Object.entries(payload).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      // objects & arrays → JSON
      if (typeof value === "object" && !(value instanceof File)) {
        formDataToSend.append(key, JSON.stringify(value));
      } else {
        formDataToSend.append(key, value);
      }
    });

    // append image separately
    if (formData.profile_image instanceof File) {
      formDataToSend.append(
        "profile_image",
        formData.profile_image,
        formData.profile_image.name,
      );
    }

    try {
      setLoading(true);

      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${userId}/`,
        formDataToSend,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success("User updated successfully!");
      localStorage.setItem("profile_image", response.data.profile_image);
      handleClose();
    } catch (error) {
      if (error.response?.data?.error) {
        const errorData = error.response.data.error;

        Object.values(errorData)
          .flat()
          .forEach((msg) => {
            toast.error(msg);
          });
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>User Profile</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleFormSubmit}>
        <Modal.Body>
          <Tabs activeKey={activeTab} onSelect={setActiveTab}>
            <Tab eventKey="employee" title="User Information">
              <Row className="mb-4 text-center">
                <div className="text-center mb-4">
                  <label htmlFor="profileImageUpload" className="d-block">
                    {previewImage ? (
                      <img
                        src={previewImage}
                        alt="Profile"
                        className="rounded-circle"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <FaUserCircle size={100} />
                    )}
                  </label>
                  <input
                    type="file"
                    id="profileImageUpload"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  <Button
                    variant="outline-primary"
                    onClick={() =>
                      document.getElementById("profileImageUpload").click()
                    }
                    className="mt-2"
                  >
                    Upload Profile Picture
                  </Button>
                </div>
              </Row>
              <Row className="mb-3 mt-3">
                <Col md={6}>
                  <Form.Label>User ID *</Form.Label>
                  <Form.Control
                    value={formData.emp_id}
                    onChange={(e) =>
                      handleNumericField("emp_id", e.target.value, 4)
                    }
                    isInvalid={!!errors.emp_id}
                  />
                </Col>

                <Col md={6}>
                  <Form.Label>Date of Joining *</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.date_joined}
                    onChange={(e) => updateField("date_joined", e.target.value)}
                    isInvalid={!!errors.date_joined}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control
                    value={formData.first_name}
                    onChange={(e) => updateField("first_name", e.target.value)}
                    isInvalid={!!errors.first_name}
                  />
                </Col>

                <Col md={6}>
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    value={formData.last_name}
                    onChange={(e) => updateField("last_name", e.target.value)}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    value={formData.email}
                    onChange={(e) => updateField("email", e.target.value)}
                    isInvalid={!!errors.email}
                  />
                </Col>

                <Col md={6}>
                  <Form.Label>Mobile *</Form.Label>
                  <Form.Control
                    value={formData.phone_number}
                    onChange={(e) =>
                      handleNumericField("phone_number", e.target.value, 10)
                    }
                    isInvalid={!!errors.phone_number}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>Designation</Form.Label>
                  <Form.Control
                    value={formData.designation}
                    onChange={(e) => updateField("designation", e.target.value)}
                  />
                </Col>

                <Col md={6}>
                  <Form.Label>Department</Form.Label>
                  <Form.Control
                    value={formData?.department}
                    onChange={(e) => updateField("department", e.target.value)}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>Gender</Form.Label>
                  <Form.Select
                    value={formData?.gender}
                    onChange={(e) => updateField("gender", e.target.value)}
                  >
                    <option value="">Select</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </Form.Select>
                </Col>

                <Col md={6}>
                  <Form.Label>Employment Type</Form.Label>
                  <Form.Select
                    value={formData?.employment_type}
                    onChange={(e) =>
                      updateField("employment_type", e.target.value)
                    }
                  >
                    <option value="permanent">Permanent</option>
                    <option value="contract">Contract</option>
                    <option value="temporary">Temporary</option>
                  </Form.Select>
                </Col>
              </Row>

              <Form.Group>
                <Form.Label>Attendance Type</Form.Label>
                <div className="d-flex gap-4 mt-2">
                  {["web/app", "machine", "both"].map((type) => (
                    <Form.Check
                      key={type}
                      type="radio"
                      label={type.toUpperCase()}
                      checked={formData?.attendence_type === type}
                      onChange={() => updateField("attendence_type", type)}
                    />
                  ))}
                </div>
              </Form.Group>
            </Tab>

            {/* ================= FAMILY / MISC TAB ================= */}
            <Tab eventKey="family" title="Family / Misc Details">
              <h6 className="mt-3">Family Details</h6>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>Father's First Name</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField(
                        "family",
                        "father_first_name",
                        e.target.value,
                      )
                    }
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>Father's Last Name</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField(
                        "family",
                        "father_last_name",
                        e.target.value,
                      )
                    }
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>Mother's First Name</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField(
                        "family",
                        "mother_first_name",
                        e.target.value,
                      )
                    }
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>Mother's Last Name</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField(
                        "family",
                        "mother_last_name",
                        e.target.value,
                      )
                    }
                  />
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={4}>
                  <Form.Label>Marital Status</Form.Label>
                  <Form.Select
                    onChange={(e) =>
                      updateNestedField(
                        "family",
                        "marital_status",
                        e.target.value,
                      )
                    }
                  >
                    <option value="">Select</option>
                    <option>Single</option>
                    <option>Married</option>
                  </Form.Select>
                </Col>

                <Col md={4}>
                  <Form.Label>Spouse First Name</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField(
                        "family",
                        "spouse_first_name",
                        e.target.value,
                      )
                    }
                  />
                </Col>

                <Col md={4}>
                  <Form.Label>Spouse Last Name</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField(
                        "family",
                        "spouse_last_name",
                        e.target.value,
                      )
                    }
                  />
                </Col>
              </Row>

              <h6>Bank Details</h6>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>Account No</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("bank", "account_no", e.target.value)
                    }
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>Bank Name</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("bank", "bank_name", e.target.value)
                    }
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <Form.Label>IFSC</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("bank", "ifsc", e.target.value)
                    }
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Branch</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("bank", "branch", e.target.value)
                    }
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Payment Type</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("bank", "payment_type", e.target.value)
                    }
                  />
                </Col>
              </Row>

              <h6>Other Details</h6>
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Label>Blood Group</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("other", "blood_group", e.target.value)
                    }
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Religion</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("other", "religion", e.target.value)
                    }
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Nationality</Form.Label>
                  <Form.Control
                    onChange={(e) =>
                      updateNestedField("other", "nationality", e.target.value)
                    }
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="salary" title="Earnings & Deductions">
              <h6 className="mt-3">User's Earning Detail</h6>
              <Row className="mb-3">
                {[
                  ["basic", "Basic Allowance"],
                  ["hra", "HRA Allowance"],
                  ["conveyance", "Conveyance Allowance"],
                  ["special", "Spl. Allowance"],
                  ["other", "Other Allowance"],
                ].map(([key, label]) => (
                  <Col md={4} key={key}>
                    <Form.Label>{label}</Form.Label>
                    <Form.Control
                      type="number"
                      value={formData.salary?.earnings?.[key] ?? ""}
                      onChange={(e) =>
                        updateNestedField("salary", "earnings", {
                          ...formData.salary.earnings,
                          [key]: e.target.value, // ✅ THIS IS THE FIX
                        })
                      }
                    />
                  </Col>
                ))}
              </Row>

              <h6 className="mt-3">User's Deduction Detail</h6>
              <Row>
                <Col md={4}>
                  <Form.Label>Advance Amount</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.salary.deductions.advance}
                    onChange={(e) =>
                      updateNestedField("salary", "deductions", {
                        ...formData.salary.deductions,
                        advance: e.target.value,
                      })
                    }
                  />
                </Col>

                <Col md={4}>
                  <Form.Label>Other Deduction</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.salary.deductions.other}
                    onChange={(e) =>
                      updateNestedField("salary", "deductions", {
                        ...formData.salary.deductions,
                        other: e.target.value,
                      })
                    }
                  />
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="qualification" title="Qualification & Experience">
              <h6 className="mt-3">Educational Qualification</h6>

              {formData.qualifications.map((q, index) => (
                <Row className="mb-3 align-items-center" key={index}>
                  <Col md={3}>
                    <Form.Control
                      placeholder="Qualification"
                      value={q.qualification}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "qualification",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      placeholder="Board / College"
                      value={q.board}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "board",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      placeholder="Marks %"
                      value={q.marks}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "marks",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      placeholder="Grade"
                      value={q.grade}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "grade",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Form.Control
                      placeholder="Year"
                      value={q.year}
                      onChange={(e) =>
                        updateArrayField(
                          "qualifications",
                          index,
                          "year",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  {/* ❌ DELETE ICON */}
                  <Col md={1} className="text-center">
                    {formData.qualifications.length > 1 && (
                      <Button
                        variant="link"
                        className="text-danger p-0"
                        onClick={() => removeRow("qualifications", index)}
                      >
                        ✖
                      </Button>
                    )}
                  </Col>
                </Row>
              ))}

              <Button
                size="sm"
                variant="outline-primary"
                onClick={() =>
                  addRow("qualifications", {
                    qualification: "",
                    board: "",
                    marks: "",
                    grade: "",
                    year: "",
                  })
                }
              >
                + Add Qualification
              </Button>

              <hr />

              <h6>Work Experience</h6>

              {formData.experiences?.map((exp = {}, index) => (
                <Row className="mb-3 align-items-center" key={index}>
                  <Col md={3}>
                    <Form.Control
                      placeholder="Previous Company"
                      value={exp.company}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "company",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      placeholder="Designation"
                      value={exp.designation}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "designation",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      placeholder="Worked Years"
                      value={exp.years}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "years",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      type="number"
                      placeholder="Annual Salary"
                      value={exp.salary}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "salary",
                          e.target.value,
                        )
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Form.Control
                      placeholder="Reason to Resign"
                      value={exp.reason}
                      onChange={(e) =>
                        updateArrayField(
                          "experiences",
                          index,
                          "reason",
                          e.target.value,
                        )
                      }
                    />
                  </Col>

                  {/* ❌ DELETE ICON */}
                  <Col md={1} className="text-center">
                    {formData?.experiences.length > 1 && (
                      <Button
                        variant="link"
                        className="text-danger p-0"
                        onClick={() => removeRow("experiences", index)}
                      >
                        ✖
                      </Button>
                    )}
                  </Col>
                </Row>
              ))}

              <Button
                size="sm"
                variant="outline-primary"
                onClick={() =>
                  addRow("experiences", {
                    company: "",
                    designation: "",
                    years: "",
                    salary: "",
                    reason: "",
                  })
                }
              >
                + Add Experience
              </Button>
            </Tab>
            <Tab eventKey="communication" title="Communication Details">
              {/* ================= RESIDENTIAL ADDRESS ================= */}
              <h6 className="mt-3">Residential Address</h6>

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={formData.resident.res_address}
                    onChange={(e) =>
                      updateNestedField(
                        "resident",
                        "res_address",
                        e.target.value,
                      )
                    }
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    value={formData.resident.res_country}
                    onChange={(e) =>
                      updateNestedField(
                        "resident",
                        "res_country",
                        e.target.value,
                      )
                    }
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    value={formData.resident.res_state}
                    onChange={(e) =>
                      updateNestedField("resident", "res_state", e.target.value)
                    }
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    value={formData.resident.res_city}
                    onChange={(e) =>
                      updateNestedField("resident", "res_city", e.target.value)
                    }
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.resident.res_pincode}
                    onChange={(e) =>
                      updateNestedField(
                        "resident",
                        "res_pincode",
                        e.target.value,
                      )
                    }
                  />
                </Col>
              </Row>

              {/* ================= SAME AS CHECKBOX ================= */}
              <Form.Check
                type="checkbox"
                className="mb-3"
                label="Permanent Address same as Residential Address"
                checked={formData.permanent.perm_same_as_res}
                onChange={(e) => handleSameAddress(e.target.checked)}
              />

              {/* ================= PERMANENT ADDRESS ================= */}
              <h6>Permanent Address</h6>

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={formData.permanent.perm_address}
                    disabled={formData.permanent.perm_same_as_res}
                    onChange={(e) =>
                      updateNestedField(
                        "permanent",
                        "perm_address",
                        e.target.value,
                      )
                    }
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    value={formData.permanent.perm_country}
                    disabled={formData.permanent.perm_same_as_res}
                    onChange={(e) =>
                      updateNestedField(
                        "permanent",
                        "perm_country",
                        e.target.value,
                      )
                    }
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    value={formData.permanent.perm_state}
                    disabled={formData.permanent.perm_same_as_res}
                    onChange={(e) =>
                      updateNestedField(
                        "permanent",
                        "perm_state",
                        e.target.value,
                      )
                    }
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    value={formData.permanent.perm_city}
                    disabled={formData.permanent.perm_same_as_res}
                    onChange={(e) =>
                      updateNestedField(
                        "permanent",
                        "perm_city",
                        e.target.value,
                      )
                    }
                  />
                </Col>
                <Col md={3}>
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.permanent.perm_pincode}
                    disabled={formData.permanent.perm_same_as_res}
                    onChange={(e) =>
                      updateNestedField(
                        "permanent",
                        "perm_pincode",
                        e.target.value,
                      )
                    }
                  />
                </Col>
              </Row>

              {/* ================= CONTACT DETAILS ================= */}
              <h6>Contact Details</h6>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Label>Mobile No</Form.Label>
                  <Form.Control
                    value={formData.contact.mobile_no}
                    onChange={(e) =>
                      handleNumericField(
                        "contact",
                        "mobile_no",
                        e.target.value,
                        10,
                      )
                    }
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>Emergency No</Form.Label>
                  <Form.Control
                    value={formData.contact.emergency_no}
                    onChange={(e) =>
                      handleNumericField(
                        "contact",
                        "emergency_no",
                        e.target.value,
                        10,
                      )
                    }
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <Spinner animation="border" role="status" size="sm">
                <span className="visually-hidden"></span>
              </Spinner>
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AgentProfile;
